import { render, staticRenderFns } from "./BMWMTableItem.vue?vue&type=template&id=49c83cf7&scoped=true&slot=header&"
import script from "./BMWMTableItem.vue?vue&type=script&lang=js&"
export * from "./BMWMTableItem.vue?vue&type=script&lang=js&"
import style0 from "./BMWMTableItem.vue?vue&type=style&index=0&id=49c83cf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c83cf7",
  null
  
)

export default component.exports